import React from "react";

// Material UI Components
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  menu: {
    margin: "15px 0px",
    cursor: "pointer",
    "& a:hover, a:active": {
      color: theme.palette.secondary.main,
    },
    width: "100%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textTransform: 'capitalize',
    fontWeight: 'normal'
  },
  container: {
    width: "100%",
    transition: "width 0.5s",
  },
  inactive: {
    width: "0",
    overflow: "hidden",
  },
  disabledLink: {
    cursor: "not-allowed",
    pointerEvents: "none",
    color: theme.palette.grey["400"],
  },
}));

const Menu = ({ items, onItemClick, currentScreen, showMenu, disabledItems = [] }) => {
  const classes = useStyles();

  const handleMenuItemClick = (e, item) => {
    e.preventDefault();
    if (disabledItems.includes(item)) {
      return;
    }
    onItemClick(item);
  };

  if (showMenu === undefined) {
    showMenu = true;
  }

  const renderMenuList = () => {
    const menuList = items.map((item) => {
      const isDisabled = disabledItems.includes(item);
      const link = (
        <Link
          onClick={(e) => handleMenuItemClick(e, item)}
          underline="none"
          color={item === currentScreen ? "secondary" : "inherit"}
          className={isDisabled ? classes.disabledLink : undefined}
        >
          {item}
        </Link>
      );

      return (
        <Typography variant="h6" className={classes.menu} key={item}>
          {isDisabled ? (
            <Tooltip title="This category is currently disabled" arrow>
              <span>{link}</span>
            </Tooltip>
          ) : (
            link
          )}
        </Typography>
      );
    });

    return menuList;
  };

  return (
    <Grid
      container
      className={
        showMenu
          ? classes.container
          : `${classes.container} ${classes.inactive}`
      }
    >
      <Grid item xs={12} md={12}>
        {renderMenuList()}
      </Grid>
    </Grid>
  );
};

export default Menu;
